import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { octoberGalleryMedia } from "../../data/octoberGalleryMedia";
import { clientGalleryFollowupMedia } from "../../data/clientGalleryFollowupMedia";
import { firm } from "../../data/site";
import { SiteLink } from "../SiteLink";
const cards = [{
  id: "answers",
  title: "Common motorcycle crash questions",
  copy: "What should I do after a motorcycle crash? Start with safety and medical care. Then learn what information to save.",
  label: "First steps after a crash",
  path: "/rider-resources/michigan-motorcycle-crash-first-24-hours/",
  image: clientGalleryFollowupMedia.crashQuestions
}, {
  id: "free-resources",
  title: "FREE resources for Michigan riders",
  copy: "Understand motorcycle insurance, no-fault benefits and injury claims with the firm’s practical guides.",
  label: "Explore the insurance guide",
  path: "/michigan-motorcycle-law-insurance-guide/",
  image: clientGalleryFollowupMedia.freeResources
}, {
  id: "community",
  title: "Giving back to the motorcycle community",
  copy: "A portion of the firm’s legal fees supports motorcycle awareness, bystander assistance and rider education programs.",
  label: "See how the firm gives back",
  path: "/helping-the-biker-community/",
  image: octoberGalleryMedia.awareness
}, {
  id: "riding-events",
  title: "Michigan motorcycle events",
  copy: "Find rides, rallies and bike nights across Michigan. Explore the event calendar and photos from the riding community.",
  label: "Explore events and photos",
  path: "/events/",
  image: clientGalleryFollowupMedia.events
}, {
  id: "meet-team",
  title: "Meet the team",
  copy: `Meet the attorneys who work with ${firm.displayName} to represent injured riders and their families.`,
  label: "Get to know the legal team",
  path: "/about-us/",
  image: clientGalleryFollowupMedia.team
}, {
  id: "client-testimonials",
  title: "Client testimonials",
  copy: "Read what clients say about their experience with the firm.",
  label: "Read client testimonials",
  path: "/law-firm-testimonials/",
  image: clientGalleryFollowupMedia.testimonials
}];
export function ResourceGallery() {
  return <section aria-labelledby="resource-gallery-title" className="resource-gallery" data-id="element-257" data-mp="1bscjamydwlw8">
    <div className="page-container resource-gallery-inner" data-id="element-258" data-mp="1prlrp0gcmbpn">
      <p className="eyebrow text-crimson" data-id="element-259" data-mp="1por45021gas0">For the road ahead</p>
      <h2 id="resource-gallery-title" className="section-title" data-id="element-260" data-mp="1lope5o5o15sk">Resources, people and community.</h2>
      <div className="image-resource-grid" data-id="element-261" data-mp="1znyr8eykrjsb">
        {cards.map(card => <SiteLink key={card.id} path={card.path} className="image-resource-card" data-id="element-262" data-mp="1uqouee8uw5ug">
          <div className="image-resource-photo" data-id="element-263" data-mp="29f35fcgff0m3"><img src={card.image.src} srcSet={card.image.srcSet} sizes="(min-width:1101px) 464px, (min-width:640px) 50vw, 100vw" width={card.image.width} height={card.image.height} alt="" loading="lazy" decoding="async" data-id="element-264" data-mp="29e1l0hdit1rp" /></div>
          <div className="image-resource-copy" id={card.id} data-id="element-265" data-mp="2ig1219ojc5un">
            <h3 data-id="element-266" data-mp="2dhg1ta9a9m67">{card.title}</h3>
            <p data-id="element-267" data-mp="2di97s90f47na">{card.copy}</p>
            <span className="image-resource-link" data-id="element-268" data-mp="2detw7g5ydgqm">{card.label} <ArrowRightIcon size={21} aria-hidden="true" data-id="element-269" data-mp="2x3rnib1ccpxj" /></span>
          </div>
        </SiteLink>)}
      </div>
    </div>
  </section>;
}